/**
 * Словарь исключений по заголовкам ошибок
 * События с заголовками, содержащими эти паттерны, не будут отправляться в Sentry
 */
const ERROR_TITLE_EXCLUSIONS = [
    /Error measurementProtocol fetch event/i,
    /ChunkLoadError/i,
    /AxiosError: Request aborted/i,
    /Attempting to use a disconnected port object/i,
    /Cannot read properties of undefined (reading 'ton')/i,
    /r.ethereum.setExternalProvider is not a function/i,
    // Добавьте сюда другие паттерны для исключения
];

/**
 * Получает заголовок ошибки из события Sentry
 * @param {Object} event - Событие из Sentry
 * @returns {string|null} - Заголовок ошибки или null
 */
const getErrorTitle = (event) => {
    // Проверяем различные источники заголовка ошибки
    return event.exception?.values?.[0]
        ? `${event.exception.values[0].type}: ${event.exception.values[0].value}`
        : null;
};

/**
 * Проверяет, нужно ли исключить событие по заголовку ошибки
 * @param {Object} event - Событие из Sentry
 * @returns {boolean} - true если событие нужно исключить
 */
const shouldExcludeByErrorTitle = (event) => {
    const errorTitle = getErrorTitle(event);
    if (!errorTitle) {
        return false;
    }

    // Проверяем заголовок на соответствие паттернам исключений
    for (const pattern of ERROR_TITLE_EXCLUSIONS) {
        if (pattern.test(errorTitle)) {
            return true;
        }
    }

    return false;
};

/**
 * Паттерны для идентификации ботов
 */
const BOT_PATTERNS = [
    /YandexBot/i,
    /Googlebot/i,
    /bot/i,
    /crawler/i,
    /spider/i,
];

/**
 * Получает user-agent из события Sentry
 * @param {Object} event - Событие из Sentry
 * @returns {string|null} - User-agent или null
 */
const getUserAgent = (event) => {
    return (
        event.request?.headers?.['User-Agent'] ||
        event.contexts?.browser?.user_agent ||
        (typeof navigator !== 'undefined' ? navigator.userAgent : null)
    );
};

/**
 * Проверяет, нужно ли исключить событие от бота
 * @param {Object} event - Событие из Sentry
 * @returns {boolean} - true если событие нужно исключить
 */
const shouldExcludeByBot = (event) => {
    const userAgent = getUserAgent(event);

    if (!userAgent) {
        return false;
    }

    // Проверяем, является ли user-agent ботом
    for (const pattern of BOT_PATTERNS) {
        if (pattern.test(userAgent)) {
            return true;
        }
    }

    return false;
};

/**
 * Фильтр событий для исключения ошибок от ботов и по заголовкам ошибок
 * @param {Object} event - Событие из Sentry
 * @returns {Object|null} - Возвращает событие или null если это событие нужно исключить
 */
export const filterBotEvents = (event) => {
    // Проверяем исключение по заголовку ошибки
    if (shouldExcludeByErrorTitle(event)) {
        return null; // Не отправлять событие в Sentry
    }

    // Проверяем исключение от ботов
    if (shouldExcludeByBot(event)) {
        return null; // Не отправлять событие в Sentry
    }

    return event;
};
